import type { Participante } from '../api/participantes';
import { JanelaModal } from './JanelaModal';

type AcaoDeSituacao = 'inativar' | 'reativar';

/** Os textos dos popups de `docs/img_refac/img_3.png`. */
const TEXTOS: Record<AcaoDeSituacao, { titulo: string; verbo: string; corpo: (nome: string) => string[] }> = {
    inativar: {
        titulo: 'Inativar participante?',
        verbo: 'Inativar',
        corpo: (nome) => [
            `Inativar ${nome} bloqueará o acesso ao tablet configurado com suas credenciais.`,
            'Você poderá reativá-lo(a) depois. Ao retornar, o(a) participante retomará a jornada na estação em que o grupo estiver.',
        ],
    },
    reativar: {
        titulo: 'Reativar participante?',
        verbo: 'Reativar',
        corpo: (nome) => [
            `Reativar ${nome} permitirá que ele(a) volte a acessar o Fiat Arcade com suas credenciais anteriores.`,
            'Ao retornar, o(a) participante continuará a jornada a partir da estação em que seu grupo estiver.',
        ],
    },
};

interface ConfirmacaoDeSituacaoProps {
    /** Só o que o texto usa: assim o modal do grupo, que tem `Jogador`, também a reaproveita. */
    participante: Pick<Participante, 'nome' | 'matricula'>;
    acao: AcaoDeSituacao;
    /** Só no modal do grupo, para o líder que será inativado: a frase do sorteio (`DP-RA-041`). */
    fraseDoLider?: string;
    processando: boolean;
    aoCancelar: () => void;
    aoConfirmar: () => void;
}

export function ConfirmacaoDeSituacao({ participante, acao, fraseDoLider, processando, aoCancelar, aoConfirmar }: ConfirmacaoDeSituacaoProps) {
    const texto = TEXTOS[acao];
    const nome = participante.nome ?? participante.matricula;
    return (
        <JanelaModal titulo={texto.titulo} aoFechar={aoCancelar} bloqueada={processando}>
            {texto.corpo(nome).map((paragrafo) => <p key={paragrafo}>{paragrafo}</p>)}
            {fraseDoLider && <p>{fraseDoLider}</p>}
            <div className="botoes-confirmacao">
                <button type="button" className="botao-secundario" onClick={aoCancelar} disabled={processando}>
                    Cancelar
                </button>
                {/* Enquanto o servidor não confirma, a operação não aparece como concluída (`RN-PT-044`). */}
                <button type="button" className={`botao-confirmar botao-${acao}`} onClick={aoConfirmar} disabled={processando}>
                    {processando ? 'Processando…' : texto.verbo}
                </button>
            </div>
        </JanelaModal>
    );
}
